import { toastr } from 'react-redux-toastr'
import branditRails from '../../../../api/brandit_rails'
import {
  setCarrierIntegrationsAction,
  setCarrierIntegrationsStatusAction,
  setCarrierIntegrationsErrorsAction,
  clearCarrierIntegrationsErrorsAction
} from './carrierIntegrations.actions'

export const fetchCarrierIntegrations = () => async dispatch => {
  try {
    dispatch(setCarrierIntegrationsStatusAction('loading'))
    dispatch(clearCarrierIntegrationsErrorsAction())

    const { data } = await branditRails.get('/carrier_integrations')

    dispatch(setCarrierIntegrationsAction(data))
    dispatch(setCarrierIntegrationsStatusAction('succeeded'))

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setCarrierIntegrationsErrorsAction({ message: errorMessage }))
    dispatch(setCarrierIntegrationsStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const createCarrierIntegration = formData => async dispatch => {
  try {
    dispatch(setCarrierIntegrationsStatusAction('loading'))
    dispatch(clearCarrierIntegrationsErrorsAction())

    const { data } = await branditRails.post('/carrier_integrations', formData)

    if (!data.oauth_url) {
      await dispatch(fetchCarrierIntegrations())
    }

    dispatch(setCarrierIntegrationsStatusAction('succeeded'))
    toastr.success('Carrier Integration', 'Carrier linked successfully!')

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setCarrierIntegrationsErrorsAction({ message: errorMessage }))
    dispatch(setCarrierIntegrationsStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const syncCarrierIntegrations = params => async dispatch => {
  try {
    dispatch(setCarrierIntegrationsStatusAction('loading'))
    dispatch(clearCarrierIntegrationsErrorsAction())

    await branditRails.post('/carrier_integration_sync', params)

    // Fetch fresh carrier integrations data instead of using sync response
    await dispatch(fetchCarrierIntegrations())

    dispatch(setCarrierIntegrationsStatusAction('succeeded'))
    toastr.success('Carrier Integration', 'Carrier integrations synced successfully!')
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setCarrierIntegrationsErrorsAction({ message: errorMessage }))
    dispatch(setCarrierIntegrationsStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const updateCarrierIntegration = (carrierId, formData) => async dispatch => {
  try {
    dispatch(setCarrierIntegrationsStatusAction('loading'))
    dispatch(clearCarrierIntegrationsErrorsAction())

    const { data } = await branditRails.put(`/carrier_integrations/${carrierId}`, formData)

    // Fetch fresh carrier integrations data after update
    await dispatch(fetchCarrierIntegrations())

    dispatch(setCarrierIntegrationsStatusAction('succeeded'))
    toastr.success('Carrier Integration', 'Carrier integration updated successfully!')

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.errors || err.message
    dispatch(setCarrierIntegrationsErrorsAction({ message: errorMessage }))
    dispatch(setCarrierIntegrationsStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}

export const deleteCarrierIntegration = carrierId => async dispatch => {
  try {
    dispatch(setCarrierIntegrationsStatusAction('loading'))
    dispatch(clearCarrierIntegrationsErrorsAction())

    await branditRails.delete(`/carrier_integrations/${carrierId}`)

    // Fetch fresh carrier integrations data after deletion
    await dispatch(fetchCarrierIntegrations())

    dispatch(setCarrierIntegrationsStatusAction('succeeded'))
    toastr.success('Carrier Integration', 'Carrier integration deleted successfully!')
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setCarrierIntegrationsErrorsAction({ message: errorMessage }))
    dispatch(setCarrierIntegrationsStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}
